import { render, staticRenderFns } from "./NoMessageSelected.vue?vue&type=template&id=0f812b2d&scoped=true&"
import script from "./NoMessageSelected.vue?vue&type=script&lang=js&"
export * from "./NoMessageSelected.vue?vue&type=script&lang=js&"
import style0 from "./NoMessageSelected.vue?vue&type=style&index=0&id=0f812b2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f812b2d",
  null
  
)

export default component.exports